import { Link } from 'react-router-dom';

export default function Card(props) {
  return (
    <div className="card">
      <h3>{props.price}</h3>
      <h4>{props.subTitle}</h4>

      {props.externalLink &&
        <a href={props.buttonUrl} className={`btn`} target="_blank">
          <span>{props.buttonTxt} {props.price}</span>
          <img src="/images/chevron-right.svg" alt="Chevron Right Icon" />
        </a>
      }

      {!props.externalLink &&
        <Link to={props.buttonUrl} className={`btn`}>
          <span>{props.buttonTxt} {props.price}</span>
          <img src="/images/chevron-right.svg" alt="Chevron Right Icon" />
        </Link>
      }
      
    </div>
  );
}
